import { DataBean } from "../DataBean";


export class TrdID extends DataBean {

    public async getTrdIDByKey(TrdIDLn: number): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.trd.TrdID_getTrdIDByKey_Number", [TrdIDLn]);
    }

}